module.exports = {
	'support.m5.m510010.wf110': {
		'theSamePersonIsTransferredTo': '同一人调同天班',
		'theSamePersonTunesDifferentDays': '同一人调不同天班',
		'transferShiftsWithOthers': '与他人调班',
		'supportForScheduling': '支援排班',
		'theSamePersonCanBeTransferred': '可新增/删除/编辑班别信息',
		'theSamePersonCanBeTransferred2': '仅可调换班别信息',
		'shiftWithAnotherPersonCanOnly': '仅可调换班别信息',
		'supportSchedulingCrossOrganizationSupportFor': '跨单位支持排班',
		'timeCheckErrors': '工时检查错误: ',
		'originalShift': '原排班信息',
		'theDateShifts': '您想调班的日期',
		'shiftBtn1': '调班日期 1',
		'shiftBtn2': '调班日期 2',
		'recalculate': '重新计算',
		'scheduledShifts': '已排班别',
		'supportShift': '支援班别',
		'viewShiftSchedule': '查看班表',
	},
	'support.errorByDateCheck': {
		'A14': '调班员工调班日期不在职',
		'B14': '对调人员对调日期不在职',
		'A31': '检查错误：该日已排班别的数量已超过每日最大可排班别数',
		'B31': '检查错误：该日已排班别的数量已超过每日最大可排班别数',
		'A32': '检查错误：已超过班表异动期限',
		'B32': '检查错误：已超过班表异动期限',
		'A33': '检查错误：仅可异动「班别排班」或「时段排班」的班别',
		'B33': '检查错误：仅可异动「班别排班」或「时段排班」的班别',
		'A34': '检查错误：仅可异动相同班别属性的班别',
		'B34': '检查错误：仅可异动相同班别属性的班别',
		'A35': '检查错误：所选日期已工时结算',
		'B35': '检查错误：所选日期已工时结算',
		'A36': '检查错误：所选日期有签核中的调班单',
		'B36': '检查错误：所选日期有签核中的调班单',
	},
	'support.errorByTransferCheck': {
		'A11': '调班员工与对调人员必须相同',
		'A12': '调班日期与对调日期必须相同',
		'A13': '调班员工不存在该公司',
		'B13': '对调人员不存在该公司',
		'A14': '调班员工调班日期不在职',
		'B14': '对调人员对调日期不在职',
		'A15': '调班日期与对调日期不可相同',
		'A16': '调班员工与对调人员不可相同',
		'A17': '调班员工调班后行事历别与班别标签不可与现况相同',
		'B17': '对调人员调班后行事历别与班别标签不可与现况相同',
		// 'A18': '调班员工调班前行事历别与班别标签与现况不相同',
		// 'B18': '对调人员调班前行事历别与班别标签与现况不相同',
		'A18': '<%=A%> 在 <%=B%> 的异动前资料已被更改',
		'B18': '<%=A%> 在 <%=B%> 的异动前资料已被更改',
		'A19': '支援排班成本中心不可为空',
		'A20': '调班日期与对调日期的历日时间不同',
		'A23': '支援排班成本中心加总不为100%',
		'A24': '支援排班成本中心ID不存在本公司',
		'A25': '调班ID不存在本公司',
		'A26': '公司表单不存在本公司',
		'A27': '调班员工调班后的班别ID不存在本公司',
		'B27': '对调人员调班后的班别ID不存在本公司',
		'A28': '调班员工调班后的标签ID不存在本公司',
		'B28': '对调人员调班后的标签ID不存在本公司',
		'A31': '调班员工已排班别不可大于每日可排班别数',
		'B31': '对调人员已排班别不可大于每日可排班别数',
		'A32': '调班员工调班日期不在班表异动期限内',
		'B32': '对调人员对调日期不在班表异动期限内',
		'A33': '调班员工调班日期的班别属性非「排班(依班别)」或「排班(依时段)」',
		'B33': '对调人员对调日期的班别属性非「排班(依班别)」或「排班(依时段)」',
		// 'A34': '调班员工调班日期班别属性不同',
		// 'B34': '对调人员对调日期班别属性不同',
		'A34': '<%=A%> 在 <%=B%> 的班别属性已异动',
		'B34': '<%=A%> 在 <%=B%> 的班别属性已异动',
		'A35': '调班员工调班日期已工时结算',
		'B35': '对调人员对调日期已工时结算',
		'A36': '调班员工调班日期有「签核中」调班单',
		'B36': '对调人员对调日期有「签核中」调班单',
		'A37': '已不开放此申请类型',
		'A38': '可异动项目未开放',
		// 'A39': '调班员工调班日期工作时间重迭',
		// 'B39': '对调人员对调日期工作时间重迭',
		'A39': '<%=A%> 在 <%=B%> 的 <%=C%> 与 <%=E%> 工作时间重迭',
		'B39': '<%=A%> 在 <%=B%> 的 <%=C%> 与 <%=E%> 工作时间重迭',
		'A40': '调班员工调班日期不符合工时规则(提醒)',
		'B40': '对调人员对调日期不符合工时规则(提醒)',
		'A41': '调班员工调班日期不符合工时规则(禁止)',
		'B41': '对调人员对调日期不符合工时规则(禁止)',
		// 'A42': '调班员工调班日期超过调班次数限制',
		// 'B42': '对调人员对调日期超过调班次数限制',
		'A42': '<%=A%> 在 <%=B%> ~ <%=C%> 的调班次数已达上限',
		'B42': '<%=A%> 在 <%=B%> ~ <%=C%> 的调班次数已达上限',
	},
	'support.errorByTransferResend': {
		'A14': '调班员工调班日期不在职',
		'B14': '对调人员对调日期不在职',
		'A31': '该日已排班别的数量已超过每日最大可排班别数',
		'B31': '该日已排班别的数量已超过每日最大可排班别数',
		'A32': '已超过班表异动期限',
		'B32': '已超过班表异动期限',
		'A33': '仅可异动「班别排班」或「时段排班」的班别',
		'B33': '仅可异动「班别排班」或「时段排班」的班别',
		'A34': '班别属性已异动',
		'B34': '班别属性已异动',
		'A35': '班别已工时结算',
		'B35': '班别已工时结算',
		'A36': '已有相同日期的签核中表单',
		'B36': '已有相同日期的签核中表单',
		'A37': '已不开放此申请类型',
		'B37': '已不开放此申请类型',
		'notInChangeableEmpIds': '已不符合可申请的异动对象',
	},
	'support.errorByInsertShift': {
		'11': '「工作时间」必填未填',
		'12': '工作时间重迭',
		'13': '休息时间与多个班别工作时间重迭',
		'14': '休息时间重迭',
		'15': '「工作时间」结束时间早于起始时间',
		'16': '「休息时间」结束时间早于起始时间',
		'17': '历日资料有误',
		'18': '「工作时间」结束时间不可等于起始时间',
		'19': '「休息时间」结束时间不可等于起始时间',
	},
	'support.m5.m510010.wf110_common': {
		'areYouSureYouWantTo': '确定要恢复默认值？',
		'restoreDefaultValues': '恢复默认值',
	},
	'support.service.m5.service-m510010_wf110': {
		'theDataHasBeenChangedBefore': '<%=temp1%> 在 <%=temp2%> 的异动前资料已被更改',
		'calendarIsRequired': '行事历别为必填栏位',
		'noSpecificWorkingHoursSet': '未自订任何工作时间',
		'reasonIsRequired': '需要填写原因',
		'attachmentIsRequired': '需要提供附件',
	},
	'support.m5.m510010.wf110_rows': {
		'adjusted': '已调整',
		'checkOutTheSchedule': '查看班表',
		'leaveInformation': '假勤资讯',
		'overtimeInformation': '加班资讯',
		'leaveStr': '请假：<%=n%> <%=unit%>',
		'leaveCancelStr': '销假：<%=n%> <%=unit%>',
		'overtimeStr': '加班：<%=n%> <%=unit%>',
	},
	'support.m5.preview.wf110': {
		'shiftAfterShift': '调班后班别',
		'thePeriodAfterTheShift': '调班后工作时间',
	},
	'support.m5.details.wf110': {
		'breakTimeAfterShifting': '调班后休息时间',
		'aTotalOfShifts': '调班共 <%=temp1%> 个',
		'aTotalOfTransactionsAreSupported': '支援班别共 <%=temp1%> 个',
		'aTotalOfScheduledShift': '已排班别共 <%=temp1%> 个',
	},
	'support.m5.m510010.wf110.download': {
		'shiftPersonnel': '调班人员',
		'scheduledWorkingHours': '当日已排工作时数',
		'workingHours': '工作时间',
		'restTime': '休息时间',
		'costCenter': '(成本中心：<%=temp%>)',
	},
	'support.sp_sa_emp_transfer_CheckDelete': {
		'11': '调班数据不存在本公司',
		'12': '表单状态必须为在途才能删除',
	},
	'support.m5.m510010.wf110_support': {
		'scheduledBreaks': '已排休息时间',
	},
};
